
import BottomNav from "../components/BottomNav";
import React, { useCallback, useEffect, useState } from "react";
import api from "../api"; // ✅ CENTRAL API

import PostCard from "../components/PostCard";
import "../theme/design.css";
import { formatDateSmart } from "../lib/time";


export default function MainFeed() {
  const [tab, setTab] = useState("recent");
  const [posts, setPosts] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [loading, setLoading] = useState(false);


  /* ---------------- Load feed ---------------- */
  const load = useCallback(
  async (reset = false) => {
    if (loading) return;
    setLoading(true);

    try {
      const params = new URLSearchParams();
      params.set("tab", tab);
      params.set("limit", "20");
      if (!reset && cursor) params.set("cursor", cursor);

      const { data } = await api.get(`/feed?${params.toString()}`);
      const list = data?.posts || [];

      setPosts((prev) => {
        if (reset) return list;

        const map = new Map(prev.map(p => [p.id, p]));
        list.forEach(p => map.set(p.id, p));
        return Array.from(map.values());
      });

      setCursor(data?.nextCursor || null);

    } catch (e) {
      console.error("feed load error", e?.response?.data || e.message);
    } finally {
      setLoading(false);
    }
  },
  [tab, cursor, loading]
);

  /* ---------------- Effects ---------------- */
  /* ---------------- Effects ---------------- */

useEffect(() => {
  setPosts([]);
  setCursor(null);
  load(true);
}, [tab]);

useEffect(() => {
  const onScroll = () => {

    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - 600
    ) {

      if (!loading && cursor) {
        load(false);
      }

    }

  };

  window.addEventListener("scroll", onScroll);

  return () => window.removeEventListener("scroll", onScroll);

}, [cursor, loading, load]);

  /* ---------------- Actions ---------------- */
  
 const handlePrivacyChange = (postId, newVisibility) => {
  if (newVisibility === "private") {
    setPosts(prev => prev.filter(p => p.id !== postId));
  }
};

  const toggleSupport = async (post) => {

  const postId = post.id;

  setPosts((prev) =>
    prev.map((p) => {

      if (p.id !== postId) return p;

      const supported = !!p.is_supported;

      return {
        ...p,
        is_supported: !supported,
        support_count: supported
          ? Math.max(0, (p.support_count || 1) - 1)
          : (p.support_count || 0) + 1,
      };

    })
  );

  try {

    await api.post(`/posts/${postId}/support`);

  } catch {

    setPosts((prev) =>
      prev.map((p) => {

        if (p.id !== postId) return p;

        const supported = !!p.is_supported;

        return {
          ...p,
          is_supported: !supported,
          support_count: supported
            ? (p.support_count || 0) + 1
            : Math.max(0, (p.support_count || 1) - 1),
        };

      })
    );

  }

};

  const doRepost = async (postId) => {
  try {
    await api.post(`/posts/${postId}/repost`);

    // update only after success
    setPosts((prev) =>
      prev.map((p) =>
        p.id === postId
          ? { ...p, repost_count: (p.repost_count || 0) + 1 }
          : p
      )
    );

    alert("Reposted to your profile.");
  } catch (e) {
    alert(e?.response?.data?.error || "Repost not allowed");
  }
};

  const shareExternally = async (postId) => {
    const url = `${window.location.origin}/post/${postId}`;
    if (navigator.share) {
      try {
        await navigator.share({ title: "Varta", url });
      } catch {}
    } else {
      await navigator.clipboard.writeText(url);
      alert("Link copied!");
    }
  };

  /* ---------------- Render ---------------- */
  return (
  <>
    <div className="page">
    <div className="tabs">
  {[
    { key: "recent", label: "Recent" },
    { key: "trending", label: "Trending" },
    { key: "mine", label: "My Interests" }
  ].map((t) => (
    <button
      key={t.key}
      className={`pill ${tab === t.key ? "active" : ""}`}
      onClick={() => setTab(t.key)}
    >
      {t.label}
    </button>
  ))}
</div>

     <div className="feed-col">
  {posts.map((p) => (
    <PostCard
      key={p.id}
      p={{ ...p, _displayDate: formatDateSmart(p.created_at) }}
      onSupport={toggleSupport}
      onRepost={doRepost}
      onShare={shareExternally}
      onPrivacyChanged={handlePrivacyChange}
    />
  ))}
</div>

      <div className="pager">
        {cursor && (
          <button
            className="btn btn-primary"
            disabled={loading}
            onClick={() => load(false)}
          >
            {loading ? "Loading…" : "Load more"}
          </button>
        )}
      </div>
    </div>
    <BottomNav />
  </>
  );
}